import { useLazyQuery } from 'src/graphql';
import { JOBS_SUMMARY } from 'src/graphql/dashboard/query';
import moment from 'moment';

export default ({ startDate = moment().startOf('isoWeek') , endDate = moment().endOf('isoWeek') }) =>
  useLazyQuery(JOBS_SUMMARY, {
    variables: { startDate, endDate },
    fetchPolicy: 'network-only',
  });
